import dayjs from 'dayjs';

export const getDateFormatByDateUnit = (value: string, dateUnit: 'day' | 'week' | 'month') => {
  switch (dateUnit) {
    case 'day':
      return dayjs(value).format('MMM DD');
    case 'week':
      return dayjs(value).format('MMM DD') + ' - ' + dayjs(value).add(6, 'day').format('MMM DD');
    case 'month':
      return dayjs(value).format('MMM YYYY');
    default:
      return value;
  }
};
